import { BarsArrowDownIcon } from "@heroicons/react/24/outline";
import Counter from "./Counter";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'

export default function StatsCard({ item  }) {
  return (
    <div
      key={item.id}
      className="relative bg-white px-4 sm:px-10 py-6 sm:py-8 rounded-2xl"
    >
      <div className="flex justify-start items-center">
        <div>
          <div className={`rounded-full p-5 ${item.bg}`}>
            <item.icon aria-hidden="true" className={`w-8 h-8 ${item.iconcolor}`} />
          </div>
        </div>
        <dd className="ml-4 w-full flex justify-between">
          <div>
            <p className="truncate text-sm font-medium text-gray-500">{item.name}</p>
            <p className="text-3xl font-bold text-gray-900">
              <Counter target={item.stat} />
            </p>
          </div>
          <div>
         
          </div>
        </dd>
      </div>
      {/* <div className="bottom-0 bg-opacity-25 ml-12 -mr-10 px-10 mt-4">
        <p className="truncate text-xs font-medium text-gray-500">{item.subname}</p>
        <p className="text-xl font-bold text-gray-500">
          <Counter target={item.substat} />
        </p>
      </div> */}
    </div>
  );
}
